'use client';

import { c as _c } from "react/compiler-runtime";
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';
import { getENV, OneTrustScripts, useCacheKey, useDeviceType, useOptimizely } from '@libs/common-next';
import { DigitalData } from '../DigitalData';
import { useCustomerKey } from './hooks';
export function TrackingScripts() {
  const $ = _c(20);
  const {
    customerKey
  } = useCustomerKey();
  const {
    cookies,
    headers
  } = useCacheKey();
  const {
    init
  } = useOptimizely();
  const pathname = usePathname();
  const {
    deviceType
  } = useDeviceType();
  let t0;
  if ($[0] !== cookies) {
    t0 = cookies.get("x-petm-team");
    $[0] = cookies;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const team = t0;
  let t1;
  if ($[2] !== headers) {
    t1 = headers.has("x-petm-bot");
    $[2] = headers;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const isBot = t1;
  let t2;
  if ($[4] !== deviceType || $[5] !== init || $[6] !== isBot || $[7] !== pathname || $[8] !== team) {
    t2 = () => {
      if (pathname) {
        init({
          pathname,
          deviceType,
          team,
          isBot
        });
      }
    };
    $[4] = deviceType;
    $[5] = init;
    $[6] = isBot;
    $[7] = pathname;
    $[8] = team;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== deviceType || $[11] !== init || $[12] !== pathname) {
    t3 = [init, pathname, deviceType];
    $[10] = deviceType;
    $[11] = init;
    $[12] = pathname;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  useEffect(t2, t3);
  let t4;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = getENV("NEXT_PUBLIC_ONETRUST_ENABLED");
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  const isOneTrustEnabled = t4;
  let t5;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <DigitalData />;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== customerKey) {
    t6 = isOneTrustEnabled && <OneTrustScripts data-testid="onetrust-script" customerKey={customerKey} />;
    $[16] = customerKey;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t6) {
    t7 = <>{t5}{t6}</>;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
}